import styled from 'styled-components';

export const ImgContainer = styled.div`
  position: relative;
  height: 250px;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0;
    transition: opacity 0.3s;
  }
`;

export const Card = styled.div`
  text-align: center;
  border: 1px solid #ededed;
  background: #fff;
  text-decoration: none;
  color: inherit;
  a {
    text-decoration: inherit;
    color: inherit;
    &:hover {
      ${ImgContainer}:after {
        opacity: 0.4;
      }
    }
  }
`;

export const Title = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin: 0;
`;

export const Date = styled.p`
  font-size: 11px;
  color: #ccc;
  margin: 10px 0 0 0;
`;

export const Author = styled.p`
  font-size: 11px;
  margin: 10px 0 0 0;
`;

export const Container = styled.div`
  padding: 16px;
`;
